angular.module("Main").controller("PaymentKursSuccessController", ["$rootScope", "$scope", "$state", "$stateParams", "$location", "$translate", "$localStorage", "PaymentService", "BookingService", "SessionService",
    function ($rootScope, $scope, $state, $stateParams, $location, $translate, $localStorage, PaymentService, BookingService, SessionService) {
        var vm = this;

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
            //unregisterEventHandler();
            $state.go('kursplan', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        });

        vm.bookingLost = false;
        vm.cashBack = false;
        vm.cookies = SessionService.checkSession();
        vm.currentUser = $localStorage.user;

        getKursbuchungLayouKonfiguration();
        loadConfigs();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.MRVerbergenKB = data.MRVerbergenKB;
                vm.NMRVerbergenKB = data.NMRVerbergenKB;
            });
        }

        $scope.$on("destroy", function () {
            logoutHandler();
        });
        vm.clubId = SessionService.getAuthData();

        if ($stateParams.message)
            vm.message = $stateParams.message;

        vm.isKurs = true;
        vm.isTermin = false;

        if (!SessionService.getSessionId()) {
            $state.go("kursplan", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
        } else
            init();


        function init() {
            vm.hasError = false;
            let userData = $localStorage.user;
            BookingService.checkStatus($stateParams.oid).then(function (status) {
                vm.status = status;
                if (status.status === 'TIMEOUT') {
                    vm.bookingLost = true;
                    if (status.PaymentFinished === true) {
                        vm.cashBack = true;
                    }
                    PaymentService.timeoutPayment(status.requestId);
                } else {
                    if (!_.isNil($stateParams.isBlock)) {
                        BookingService.getBlockkursTermine($stateParams.bNr).then(function (data) {
                            vm.hasBlockkurse = true;
                            _.forEach(data, function (d) {
                                d.Tag = new Date(d.Start);
                                d.Tag = moment(d.Tag).format('YYYY-MM-DD').toString();
                                d.Start = moment(d.Start).format('HH:mm').toString();
                                d.Ende = moment(d.Ende).format('HH:mm').toString();
                            });
                            vm.blockkurse = data;
                            vm.kursData = ({
                                OrderNr: $stateParams.oid,
                                Bezeichnung: vm.status.artikel,
                                PreisZahl: vm.status.preis,
                                Blockkurse: vm.blockkurse,
                                PersonNr: vm.status.personNr,
                                RessourcenIds: vm.status.ressourcesIds,
                                TerminNr: vm.status.terminNr,
                                Bezahlung: vm.status.bezahlung
                            });
                        })
                    } else {
                        vm.kursData = ({
                            OrderNr: $stateParams.oid,
                            Bezeichnung: vm.status.artikel,
                            PreisZahl: vm.status.preis,
                            Start: vm.status.start,
                            Ende: vm.status.ende,
                            PersonNr: vm.status.personNr,
                            RessourcenIds: vm.status.ressourcesIds,
                            TerminNr: vm.status.terminNr
                        });
                    }

                    bookIntoMV();
                    if (!status.confirmed && status.status !== "ERROR") {
                        PaymentService.confirmPaymentKurs($stateParams.rid).then(function () {
                            vm.isPayment = true;
                            vm.zahlmethode = 'SixPayments';
                            BookingService.saveAppointmentHistory(vm.kursData.TerminNr, 8, 4,
                                {orderId: $stateParams.oid});
                            getDataByRIDForConfirm();
                        })
                    }
                }
            });

            vm.remindLocalePayment = $stateParams.locale;
        }

        vm.goto = function () {
            $state.go("kursplan", {sid: SessionService.getSessionId(), cid: $scope.cid, id: $scope.id});
        };

        function getDataByRIDForConfirm() {
            vm.member = {};
            SessionService.setAuthData($stateParams.cid);
            BookingService.getUserDataByRIDForConfirm($stateParams.rid).then(function (data) {
                vm.member.email = data.email;
                vm.member.firstName = data.firstname;
                vm.member.lastName = data.lastname;
            })
        }

        function bookIntoMV() {
            PaymentService.saveMVBooking($stateParams.oid, $translate.use()).then(function (data) {
                if ((data && !_.isEmpty(data.rechnungsNr))) {
                    vm.kursData.OrderNr = data.rechnungsNr;
                }
                if (data.data && !_.isEmpty(data.data.rechnungsNr)) {
                    vm.kursData.OrderNr = data.data.rechnungsNr;
                }
            }).catch(function () {
                vm.hasError = true;
                $state.go("booking_kurs_error", {
                    cid: $stateParams.cid,
                    id: $stateParams.id,
                    oid: $stateParams.oid,
                    isKurs: true
                });
            })
        }

    }]);
